import descriptionReport from './descriptionReport'
import convertRisk from './convertRisk'

const ripds = {
  descriptionReport,
  convertRisk,
}

export default ripds
